/* unplugin-vue-components disabled */import { render } from "./UserGroupsSelect.vue?vue&type=template&id=3e153b8f&ts=true"
import script from "./UserGroupsSelect.vue?vue&type=script&lang=ts"
export * from "./UserGroupsSelect.vue?vue&type=script&lang=ts"

import "./UserGroupsSelect.vue?vue&type=style&index=0&id=3e153b8f&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__